import { MaskLines, Reveal } from "@/components/site/motion";

export const PageHero = ({ eyebrow, lines, intro, bg = "#ff2e63", fg = "#fff5e8", children, testId = "page-hero", art }) => (
  <section data-testid={testId} className="grain relative overflow-hidden pb-16 pt-36 sm:pb-24 sm:pt-44" style={{ background: bg, color: fg }}>
    {art}
    <div className="wrap relative">
      <p className="eyebrow opacity-90">{eyebrow}</p>
      <MaskLines as="h1" onMount lines={lines} delay={0.15} className="mt-5 font-display text-[15vw] font-extrabold uppercase leading-[0.84] tracking-[-0.04em] sm:text-[11vw] lg:text-[8.5vw]" />
      {intro && (
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-2xl text-lg font-medium sm:text-xl">{intro}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
